// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shadow-box {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    padding: 10px;
    margin: 10px;
    border-radius: 10px;
    margin-top: 10px;
}

#filter_input:focus {
    outline: none !important;
    border-color:rgba(0, 0, 0, 0.24);
    box-shadow: 0 0 10px #deedfa;
}

.field_input {
    width: 120px;
    border: none;
    background-color: #f5f5f5;
    border-radius: 5px;
    font-weight: 500;
    height: 35px
}

.field_input:focus {
    outline: none !important;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    transition: 0.5s;
}

.filed_select {
    height: 35px;
    background-color: #f5f5f5;
    border-radius: 5px;
    text-align: center;
    vertical-align: center;
    padding-top: 6px;
    min-width: 150px;
}

.center {
    text-align: center;
}

.cognito_signal {
    width: 12px;
    height: 12px;
    border-radius: 50%;
}


.abosulte-container {
    position: absolute;
    width: 100vw;
    height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/user-management/user-management.component.css"],"names":[],"mappings":"AAAA;IACI,wFAAwF;IACxF,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,wBAAwB;IACxB,4EAA4E;IAC5E,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".shadow-box {\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n    padding: 10px;\n    margin: 10px;\n    border-radius: 10px;\n    margin-top: 10px;\n}\n\n#filter_input:focus {\n    outline: none !important;\n    border-color:rgba(0, 0, 0, 0.24);\n    box-shadow: 0 0 10px #deedfa;\n}\n\n.field_input {\n    width: 120px;\n    border: none;\n    background-color: #f5f5f5;\n    border-radius: 5px;\n    font-weight: 500;\n    height: 35px\n}\n\n.field_input:focus {\n    outline: none !important;\n    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;\n    transition: 0.5s;\n}\n\n.filed_select {\n    height: 35px;\n    background-color: #f5f5f5;\n    border-radius: 5px;\n    text-align: center;\n    vertical-align: center;\n    padding-top: 6px;\n    min-width: 150px;\n}\n\n.center {\n    text-align: center;\n}\n\n.cognito_signal {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n}\n\n\n.abosulte-container {\n    position: absolute;\n    width: 100vw;\n    height: 80vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
